"use client";

import { useGameOnboarding } from "@/hooks/games/useGameOnboarding";
import { type ReactNode, createContext, useContext } from "react";

type GameOnboardingContextValue = ReturnType<typeof useGameOnboarding>;

const GameOnboardingContext = createContext<
  GameOnboardingContextValue | undefined
>(undefined);

interface GameOnboardingProviderProps {
  children: ReactNode;
}

export const GameOnboardingProvider = ({
  children,
}: GameOnboardingProviderProps) => {
  const gameOnboardingValue = useGameOnboarding();

  return (
    <GameOnboardingContext.Provider value={gameOnboardingValue}>
      {children}
    </GameOnboardingContext.Provider>
  );
};

export const useGameOnboardingContext = () => {
  const context = useContext(GameOnboardingContext);
  if (context === undefined) {
    throw new Error(
      "useGameOnboardingContext must be used within a GameOnboardingProvider",
    );
  }
  return context;
};
